import { render, staticRenderFns } from "./DocumentDeletePages.vue?vue&type=template&id=7fcf1afe&scoped=true&"
import script from "./DocumentDeletePages.vue?vue&type=script&lang=js&"
export * from "./DocumentDeletePages.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDeletePages.vue?vue&type=style&index=0&id=7fcf1afe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcf1afe",
  null
  
)

export default component.exports